module.exports = __webpack_public_path__ + "img/back7.08dcb0bf.png";